
// Strips the first two characters from a 12-character OrgNumber for display purposes only.
export const StripFirstTwoOrgNo = (input) => {
    if (input && input.length === 12) {
        return input.substring(2);
    }
    return input;
};